import {IInternationalTargetAccount} from "../domain/accounts/IInternationalTargetAccount";
import {ETargetAccountType} from "../enums/ETargetAccountType";

export class InternationalTargetAccountEntity implements IInternationalTargetAccount {
  id: number;
  address1: string;
  address2: string;
  bankName: string;
  birthDate: string;
  cardNumber: string;
  cellphone: string;
  city: string;
  country: string;
  driverLicenceNumber: string;
  postalCode: string;
  ssn: string;
  state: string;
  status: number;
  type: ETargetAccountType;
  accountNumber: number;
  alias: string;
  firstName: string;
  additionalNames: string;
  lastName: string;
  birthday: string;

  constructor() {
    this.id = null;
    this.address1 = null;
    this.address2 = null;
    this.bankName = null;
    this.birthDate = null;
    this.cardNumber = null;
    this.cellphone = null;
    this.city = null;
    this.country = 'MX';
    this.driverLicenceNumber = null;
    this.postalCode = null;
    this.ssn = null;
    this.state = null;
    this.status = 2;
    this.type = null;
    this.accountNumber = null;
    this.alias = null;
    this.firstName = null;
    this.additionalNames = null;
    this.lastName = null;
  }

}